"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useRoomRange = (absMin = 0, absMax = 1000) => {
  const ABSOLUT_MIN = absMin;
  const ABSOLUT_MAX = absMax;
  const [minValue, setMinValue] = (0, _react.useState)(ABSOLUT_MIN);
  const [maxValue, setMaxValue] = (0, _react.useState)(ABSOLUT_MAX);
  function setMin(min) {
    if (min === undefined || min === null) {
      setMinValue(ABSOLUT_MIN);
    } else {
      const newMinVal = Math.max(ABSOLUT_MIN, Math.min(ABSOLUT_MAX, min));
      if (newMinVal < (maxValue || ABSOLUT_MAX)) {
        setMinValue(newMinVal);
      }
    }
  }
  function setMax(max) {
    if (max === undefined || max === null) {
      setMaxValue(ABSOLUT_MAX);
    } else {
      const newMaxVal = Math.max(ABSOLUT_MIN, Math.min(ABSOLUT_MAX, max));
      if (newMaxVal > (minValue || ABSOLUT_MIN)) {
        setMaxValue(newMaxVal);
      }
    }
  }
  function setRange(min, max) {
    setMin(min);
    setMax(max);
  }
  return {
    setRange,
    min: minValue,
    max: maxValue,
    absoluteMIN: ABSOLUT_MIN,
    absoluteMAX: ABSOLUT_MAX
  };
};
var _default = exports.default = useRoomRange;